import { render } from "./ViewPageHeader.vue?vue&type=template&id=458d4c56&scoped=true"
import script from "./ViewPageHeader.vue?vue&type=script&lang=js"
export * from "./ViewPageHeader.vue?vue&type=script&lang=js"

import "./ViewPageHeader.vue?vue&type=style&index=0&id=458d4c56&scoped=true&lang=css"

import exportComponent from "D:\\workfile\\flycat\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458d4c56"]])

export default __exports__